class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.sellingPlanInput = this.form.querySelector('[name="selling_plan"]');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.form.querySelector('[name="add"]');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent,
    );
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.updateOptions();
    this.updateVariant();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('disabled');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    formData.append(
      'sections',
      this.cartDrawer.getSectionsToRender().map((section) => section.section),
    );
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper) return;
    errorWrapper.classList.toggle('hidden', !errorMessage);
    errorWrapper.textContent = errorMessage || '';
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    if (event.target.name === 'product-plan') {
      event.target.value === 'one-time'
        ? this.clearSellingPlan()
        : this.updateSellingPlan();
      return;
    }
    if (event.target.name === 'product-plan-option') {
      this.querySelector(
        '[name="product-plan"][value="subscribe"]',
      ).checked = true;
      this.updateSellingPlan(
        event.target.value,
        event.target.dataset.price,
        event.target.dataset.discount,
      );
      return;
    }
    this.updateOptions();
    this.updateVariant();
    this.toggleAddButton(false, '');
    this.handleErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  clearSellingPlan() {
    this.sellingPlanInput.value = '';
    Array.from(this.querySelectorAll('[name="product-plan-option"]')).map(
      (el) => (el.checked = false),
    );
    this.submitButton.textContent = `${window.variantStrings.addToCart} - ${
      this.querySelector('[name="product-plan"][value="one-time"]').dataset
        .price
    }`;
  }

  updateSellingPlan(id, price, discount) {
    if (id) {
      this.sellingPlanInput.value = id;
      this.querySelector('#ProductPlan-Price').textContent = price;
      this.querySelector('#ProductPlan-Discount').textContent = discount;
      this.submitButton.textContent = `${window.variantStrings.addToCart} - ${price}`;
      return;
    }

    const firstSellingPlan = this.currentVariant.selling_plan_allocations[0];
    const firstOption = this.querySelector('[name="product-plan-option"]');

    this.sellingPlanInput.value = firstSellingPlan.selling_plan_id;
    this.querySelector('#ProductPlan-Price').textContent =
      firstOption.dataset.price;
    this.querySelector('#ProductPlan-Discount').textContent =
      firstOption.dataset.discount;
    this.submitButton.textContent = `${window.variantStrings.addToCart} - ${firstOption.dataset.price}`;
    this.querySelector('[name="product-plan-option"]').checked = true;
  }

  updateOptions() {
    const selectors = this.querySelectorAll(
      'input:not([name*="product-plan"])[type="radio"]:checked, select',
    );

    if (selectors.length === 0) {
      this.options = this.variants[0].options;
      return;
    }

    this.options = Array.from(selectors, (el) => el.value);
  }

  updateVariant() {
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector('product-media');
    productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }

  updateVariantInput() {
    const input = this.querySelector('[name="id"]');
    input.value = this.currentVariant.id;
  }

  setUnavailable() {
    const submitButton = this.querySelector('[name="add"]');
    const price = this.querySelector(`#price-${this.dataset.sectionId}`);

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  toggleAddButton(disable, text) {
    const submitButton = this.querySelector('[name="add"]');

    if (disable) {
      submitButton.setAttribute('disabled', 'disabled');
      if (text) submitButton.textContent = text;
    } else {
      submitButton.removeAttribute('disabled');
      submitButton.textContent = window.variantStrings.addToCart;
    }
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destinationPrice = document.querySelector(
          `#price-${this.dataset.sectionId}`,
        );
        const sourcePrice = html.querySelector(
          `#price-${this.dataset.sectionId}`,
        );

        if (destinationPrice && sourcePrice) {
          destinationPrice.classList.remove('visibility-hidden');
          destinationPrice.innerHTML = sourcePrice.innerHTML;
        }
      });
  }
}

customElements.define('product-selector', ProductSelector);
